import React from "react";
import styled from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// styles
import colors from "core/colors";
export const DisplayTextStyled = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${colors.secondary.oolong};
`;

// component
export const DisplayText = () => {
    const { selectedOption, controlLabelOverride } = useFormSelectDialog();

    const displaytext =
        controlLabelOverride ||
        selectedOption.controlLabelOverride ||
        selectedOption.label;

    return <DisplayTextStyled>{displaytext}</DisplayTextStyled>;
};

export default DisplayText;
